"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatTile = StatTile;
const jsx_runtime_1 = require("react/jsx-runtime");
const utils_1 = require("../utils");
// "Focus stat" tile from the dashboard mocks. Compose with `Card` for the
// outer surface; this primitive is the inner ramp.
//   value     30px extrabold tabular-nums neutral-900
//   label     12px neutral-500
//   delta     12px bold, tinted by trend (up = catch-green, down = primary-red,
//             flat = neutral-500). The arrow glyph is text — no icon needed.
const trendStyles = {
    up: 'text-primary-green',
    down: 'text-primary-red',
    flat: 'text-neutral-500'
};
const trendGlyph = {
    up: '↑',
    down: '↓',
    flat: '→'
};
function StatTile({ label, value, subLabel, delta, trend = 'flat', icon, className }) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, utils_1.cn)('flex items-start justify-between gap-3', className), children: [(0, jsx_runtime_1.jsxs)("div", { className: 'min-w-0', children: [(0, jsx_runtime_1.jsx)("div", { className: 'text-xs font-medium text-neutral-500', children: label }), subLabel ? (0, jsx_runtime_1.jsx)("div", { className: 'mt-0.5 text-[11px] text-neutral-400', children: subLabel }) : null, (0, jsx_runtime_1.jsx)("div", { className: 'mt-2 text-3xl font-extrabold tracking-[-0.015em] tabular-nums text-neutral-900', children: value }), delta ? ((0, jsx_runtime_1.jsxs)("div", { className: (0, utils_1.cn)('mt-1 inline-flex items-center gap-1 text-xs font-bold', trendStyles[trend]), children: [(0, jsx_runtime_1.jsx)("span", { "aria-hidden": 'true', children: trendGlyph[trend] }), delta] })) : null] }), icon ? (0, jsx_runtime_1.jsx)("div", { className: 'shrink-0 text-neutral-300', children: icon }) : null] }));
}
